import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `12px ${spacing.xs}`,
        backgroundColor: colors.grey.grey1,
        width: '100%',
        '& > * + *': {
            marginTop: spacing.xs,
        },
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'center',
            '& > * + *': {
                marginTop: 0,
            },
        },
    },
    // Mobile (< sm): stacked column — summaryItems fills width
    // sm+: centered row — date and postcode side-by-side, startAgain inline (via CSS order on root)
    topRow: {
        display: 'flex',
        alignItems: 'flex-start',
        width: '100%',
        marginBottom: spacing.xs,
        [theme.breakpoints.up('sm')]: {
            alignItems: 'center',
            justifyContent: 'center',
            width: 'auto',
            flex: '0 0 auto',
            marginBottom: 0,
        },
    },
    summaryItems: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        minWidth: 0,
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            flex: 'unset',
            minWidth: 'unset',
            '& > *:not(:last-child)': {
                marginRight: spacing.xs,
            },
        },
    },
    summaryItem: {
        display: 'flex',
        alignItems: 'center',
        '& > *:not(:last-child)': {
            marginRight: spacing.xxs,
        },
        [theme.breakpoints.up('md')]: {
            '& > *:not(:last-child)': {
                marginRight: spacing.xs,
            },
        },
    },
    checkIcon: {
        color: colors.siteNoticeColor.GREEN,
        fontSize: '24px',
        flexShrink: 0,
        [theme.breakpoints.up('md')]: {
            fontSize: '28px',
        },
    },
    summaryText: Object.assign(Object.assign({}, theme.typography.xxs_regular), { color: colors.supplementary.black, wordBreak: 'break-word', [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.small_regular) }),
    startAgainLink: Object.assign(Object.assign({}, theme.typography.xxs_regular), { color: colors.supplementary.black, textDecoration: 'underline', cursor: 'pointer', flexShrink: 0, background: 'none', border: 'none', padding: 0, textAlign: 'left', whiteSpace: 'nowrap', alignSelf: 'flex-start', '&:hover': {
            opacity: 0.8,
        }, '&:focus-visible': {
            outline: `2px solid ${colors.supplementary.black}`,
            outlineOffset: '2px',
        }, [theme.breakpoints.up('sm')]: {
            order: 1,
            flex: '0 0 auto',
            textAlign: 'left',
            alignSelf: 'center',
            marginLeft: spacing.small,
        }, [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.small_regular) }),
    confirmationMessage: Object.assign(Object.assign({}, theme.typography.xxs_bold), { color: colors.supplementary.black, width: '100%', [theme.breakpoints.up('sm')]: {
            textAlign: 'center',
            order: 2,
            marginTop: spacing.xs,
        }, [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.small_bold) }),
}));
export default useStyles;
